// @core/api/endpoints/localization/get_translation_bundle.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  TranslationBundleResponse,
} from '../../../types/localization';

const BASE_PATH = '/localization';

/**
 * Get translation bundle
 * Returns all translations for a locale+namespace as a key-value map. Supports ETag caching for efficient frontend loading.
 * @public This endpoint does not require authentication
 */
export async function GetTranslationBundle(
  locale_code: string,
  namespace_slug: string,
  options?: RequestOptions
): Promise<TranslationBundleResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/localization/bundles/:locale_code/:namespace_slug`;
  requestPath = requestPath.replace(':locale_code', encodeURIComponent(locale_code));
  requestPath = requestPath.replace(':namespace_slug', encodeURIComponent(namespace_slug));
  const requestOptions = { ...options, skipAuth: true };
  return client.get<TranslationBundleResponse>(requestPath, { ...requestOptions });
}
